import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  return {
    needed: Boolean(
      jsonNode.type === 'LineBreak' &&
      jsonNode.data?.sym?.inst === 'LineBreak' &&
      jsonNode.classes &&
      jsonNode.classes?.length > 0
    ),
    logData: {
      msg: `LineBreak plugin components should not have classes`,
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.classes = [];
    },
  };
};
